import styled from 'styled-components';
import { media } from 'theme/breakpoints';

export const Header = styled.header`
  padding: 5rem 0 5rem;
  width: 90%;
  margin: 0 auto;
  ${media.desktop} {
    padding: 12rem 0 2rem;
  }
  ${media.tablet} {
    padding: 7rem 0 2rem;
  }
`;

export const Title = styled.h1`
  text-align: center;
  margin: auto;
  max-width: 960px;

  ${media.tablet} {
    font-size: 28px;
    line-height: 38px;
  }
  &.line {
    span {
      &::after {
        /* background-color: #ffe478; */
      }
      ${media.tablet} {
        display: inline-block;
      }
    }
  }
`;

export const Description = styled.p`
  text-align: center;
  font-size: 20px;
  line-height: 30px;
  font-weight: 400;
  margin-top: 24px;
  ${media.tablet} {
    font-size: 18px;
    line-height: 23px;
  }
`;
